import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, OnDestroy ,EventEmitter} from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Subject } from 'rxjs'
import { Profile } from '../../Models/profile.interface';
import { LessonManagerService } from '../../Services/LessonManager/lesson-manager.service';
import { LessonCard } from '../../Models/lessons.interface';
import { AngularFirestore } from '@angular/fire/firestore';
import { PROFILES } from 'src/Constants';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit, OnChanges, OnDestroy {
@Input() id: string;
@Output() close = new EventEmitter<null>();
  uid;
  leaving = new Subject<any>()
  profile: Profile
  confirmations = Array<Confirmation>()
  cards: Array<LessonCard>
  confs = [
    17,18,19,15,19,17,18,19,17,18,20,17,19,16,17,15,20,14,17,17,17,19,21,17,19
  ]
  constructor(
    private db: AngularFireDatabase, 
    private afs: AngularFirestore,
    private lm: LessonManagerService) { 
    this.cards = this.lm.getLessonCards()
  }

  ngOnInit() {

    // console.log("profile for ", this.id)
  }
  ngOnChanges(changes: SimpleChanges){
    var u = changes['id'].currentValue
    if(u){
      this.getUser(u)
    }
  }

  getUser(uid: string){
    this.afs.doc<Profile>(`${PROFILES}/${uid}`)    
    .valueChanges()
    .takeUntil(this.leaving)
    .subscribe(profile =>  {
      // console.log(profile)
      this.profile = profile
      this.confirmations = profile.confirmations as Array<Confirmation>
    })
  }

  ngOnDestroy(){
    this.leaving.next(null)
    this.confirmations = []
    this.profile = null
  }

  onClose(e){
    e.stopPropagation()
    this.close.emit(null)
    this.ngOnDestroy()
  }

  doNothing(e){
    e.stopPropagation()
  }

}
interface Confirmation{index: any, response: any}
